/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function Seo({
  description,
  lang,
  meta,
  image: metaImage,
  title,
  pathname,
  keywords,
}) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
          keywords
        }
      }
    }
  `)

  const metaDescription = description || site.siteMetadata.description
  const metaKeywords = keywords || site.siteMetadata.keywords
  const defaultTitle = site.siteMetadata?.title
  const image =
    metaImage && metaImage.src
      ? `${metaImage.src}`
      : `${site.siteMetadata.siteUrl}/images/default_preview.jpg`

  let langPath = ""
  if (lang === "en-US") {
    langPath = "/en-us"
  }
  //const langShort = lang.split("-")[0]

  const canonical = pathname
    ? `${site.siteMetadata.siteUrl}${langPath}/${pathname}/`
    : null

  if (!canonical) {
    //console.log("CANONICAL null: " + title)
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      link={
        canonical
          ? [
              {
                rel: "canonical",
                href: canonical,
              },
            ]
          : []
      }
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `viewport`,
          content: `width=device-width, initial-scale=1, shrink-to-fit=no`,
        },
        {
          property: `og:url`,
          content: canonical,
          prefix: `og: https://ogp.me/ns#`,
        },
        {
          name: `keywords`,
          content: metaKeywords?.join(","),
        },
        {
          property: `og:title`,
          content: title,
          prefix: `og: https://ogp.me/ns#`,
        },
        {
          property: `og:description`,
          content: metaDescription,
          prefix: `og: https://ogp.me/ns#`,
        },
        {
          property: `og:type`,
          content: `website`,
          prefix: `og: https://ogp.me/ns#`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `fb:app_id`,
          content: "1648983785295399",
        },
        {
          property: "og:image",
          content: image,
          prefix: `og: https://ogp.me/ns#`,
        },
        {
          name: `twitter:image`,
          content: image,
        },
      ]
        .concat(
          metaImage
            ? [
                {
                  property: "og:image:width",
                  content: metaImage.width,
                },
                {
                  property: "og:image:height",
                  content: metaImage.height,
                },
              ]
            : [
                {
                  name: "twitter:card",
                  content: "summary",
                },
              ],
        )
        .concat(meta)}
    />
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  pathname: PropTypes.string,
  keywords: PropTypes.arrayOf(PropTypes.string),
}

export default Seo
